import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import * as Notify from "@repoflow/form-schema/notify";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as QueriesQL from "queries/bucket";

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>Create</BreadcrumbItem>;

export const Content = ({
  history,
}) => {
  const { base } = useSectionContext();
  const initial = {
    description: "",
    exts: [],
    size: 10000000,
    minFileSize: 1000,
    maxFileSize: 1000000,
  };

  return (
    <Mutation
      initial={initial}
      target={{ $ref: "/Public/Bucket/Create" }}
      mutation={QueriesQL.create}
      update={QueriesQL.update({})}
      onMutate={({ handler, state: { values: input } }) => {
        handler({ variables: { input } });
      }}
      onCompleted={() => {
        history.replace(base);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ target, state, schema, mutate }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    onSubmit: () => {
      mutate();
    },
    onChange: (values) => {
      setValues(values);
    },
    config: {
      "/Public/Bucket/Create": {
        fields: [
          "description",
          "size",
          "exts",
          "minFileSize",
          "maxFileSize",
        ],
      },
    },
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit">Create</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
